module.exports = __webpack_public_path__ + "static/media/Lance Mambondiani.fb5a1970.jpg";